import EA from '../helpers/init';

export default EA.Methods.openAudioPlayer = ($this) => {
    const playerButton = $this;
    const audioPlayer = $this.querySelector('.hidden-audio-player');

    playerButton.addEventListener('click', (e) => {
        e.stopPropagation();
        audioPlayer.classList.toggle('active');
    });

    document.addEventListener('click', () => {
        audioPlayer.classList.remove('active');
    });
};
